import { Routes, Route } from 'react-router-dom';
import ViewerPage from './viewer/ViewerPage';
import AdminShell from './admin/AdminShell';
import Dashboard from './admin/Dashboard';
import ProjectPage from './admin/ProjectPage';
import LinkVisitsPage from './admin/LinkVisitsPage';
import DocAnalyticsPage from './admin/DocAnalyticsPage';

export default function App() {
  return (
    <Routes>
      {/* Public viewer — no SSO. The server enforces all gates; this route
          merely renders whatever gate state the API returns. */}
      <Route path="/v/:slug" element={<ViewerPage />} />

      {/* Admin — SSO-gated inside AdminShell. */}
      <Route element={<AdminShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/p/:projectId" element={<ProjectPage />} />
        <Route path="/p/:projectId/links/:linkId" element={<LinkVisitsPage />} />
        <Route path="/p/:projectId/docs/:docId" element={<DocAnalyticsPage />} />
      </Route>
    </Routes>
  );
}
